import { TAB_CHANGE } from 'actionTypes/appDrawer';
import type { AppDrawerPossibleTabs } from 'reducers/initialstate/appDrawer';

const changeAppDrawerTab = (nextTab: AppDrawerPossibleTabs) => {
  return { type: TAB_CHANGE, payload: nextTab };
};

export { changeAppDrawerTab };
